export enum RetirementAccountTypeOption {
	IRA = 'IRA',
	RothIRA = 'Roth IRA',
	Annuity = 'Annuity',
	Retirement401k = '401k',
	Pension = 'Pension',
}